import comp from '../components/barrel';
import svg from '../js/svg';
import U from '../js/utils';
import listReturnState from '../js/listReturnState';

const EP = 'advisors/get-advisors';
const MARKETERS_EP = 'communal/marketers';
const GROUPS_EP = 'advisors/get-advisor-groups';
const CREATE_GROUP_EP = 'advisors/create-user-group';
const PAGE_SIZE = 50;
const COL_COUNT = 15;

let advisorListTimeout = null;
let advisorKeywordTimeout = null;
let advisorColumnFilterTimeout = null;

function cellText(val) {
  return val != null && String(val).trim() !== '' ? String(val) : '';
}

function ynText(val) {
  if (val === true) return 'Yes';
  if (val === false) return 'No';
  return '—';
}

async function dateText(val) {
  if (val == null || String(val).trim() === '') return '—';
  return await U.formatDate(val);
}

function parseDateOnly(val) {
  if (val == null || String(val).trim() === '') return null;
  const m = String(val).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
}

function styleOverdueCrmFollowUp(cell, crmFollowUp, lastContactReport) {
  const crm = parseDateOnly(crmFollowUp);
  const lastContact = parseDateOnly(lastContactReport);
  if (!crm || !lastContact) return;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (crm < today && lastContact < crm) {
    cell.classList.add('font-bold');
    cell.style.color = '#dc2626';
  }
}

function marketerName(row) {
  return `${cellText(row.marketer_f_name)} ${cellText(row.marketer_s_name)}`.trim();
}

function isPrivateGroup(row) {
  return row && (row.private_yn === true || row.private_yn === 'true' || row.private_yn === 1);
}

function userGroupDisplayName(row) {
  const name = row && row.group_name != null ? String(row.group_name) : '';
  return isPrivateGroup(row) ? `${name} (Pvt)` : name;
}

function allGroupDisplayName(row) {
  const name = row && row.group_name != null ? String(row.group_name) : '';
  const type = row && row.group_type != null && String(row.group_type).trim() !== '' ? String(row.group_type).trim() : '';
  const prefix = type ? `[${type}] ` : '';
  return `${prefix}${name}`;
}

function columnFilterHead(label, inputId, value) {
  const wrap = document.createElement('div');
  wrap.className = 'advisor-col-filter';
  const title = document.createElement('div');
  title.textContent = label;
  const input = document.createElement('input');
  input.type = 'text';
  input.id = inputId;
  input.name = inputId;
  input.className = 'advisor-col-filter-input';
  input.autocomplete = 'off';
  input.value = value || '';
  input.addEventListener('input', (e) => {
    e.stopPropagation();
    if (thsPage && typeof thsPage.onColumnFilterInput === 'function') thsPage.onColumnFilterInput();
  });
  wrap.appendChild(title);
  wrap.appendChild(input);
  return wrap;
}

function selectedGroupFilterIds(containerId) {
  const root = U.id(containerId);
  if (!root) return [];
  return [...root.querySelectorAll('input[type="checkbox"][data-group-id]')]
    .filter((cb) => cb.checked)
    .map((cb) => cb.dataset.groupId)
    .filter((id) => id != null && String(id).trim() !== '');
}

export default {
  async prepare() {
    const listRestore = this.vars && this.vars.listRestore;
    this.initActiveFlags(listRestore);
    if (listRestore) {
      this.vars.selected_page = listRestore.selected_page || 1;
    } else {
      this.vars.selected_page = 1;
    }
    this.recipe.methods.push(await O.mPOST(EP, this.buildRequestVars(this.vars.selected_page)));
    this.recipe.methods.push(await O.mPOST(GROUPS_EP, {}));
    this.recipe.methods.push(await O.mPOST(MARKETERS_EP, {}));
  },

  async render() {
    const rec = this.recipe.methods;
    let data = {};
    if (rec.length) {
      data = await O.PREP(rec);
    }
    await this.loadPage(data);
  },

  async loadPage(data) {
    const groupsRes = data[GROUPS_EP] || {};
    this.advisorGroupsData = Array.isArray(groupsRes.data) ? groupsRes.data : [];
    const marketersRes = data[MARKETERS_EP] || {};
    this.marketersData = Array.isArray(marketersRes.data)
      ? marketersRes.data.map((row) => ({
          ...row,
          fullName: `${cellText(row.f_name)} ${cellText(row.s_name)}`.trim() || cellText(row.user_uuid),
        }))
      : [];

    const listReturn = this.vars && this.vars.listRestore;

    setTimeout(() => {
      if (listReturn && listReturn.filters) {
        this.applyListReturnToDom(listReturn);
      } else {
        this.syncActiveCheckboxesFromVars();
        this.syncMarketerSelectFromVars();
      }
      this.setupSearchInputEvents();
    }, 0);

    const clearBtn = U.id('clearAdvisorFilters');
    if (clearBtn) {
      clearBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.getAdvisorList(true);
      });
    }

    const yesCheckbox = U.id('activeYesCheckbox');
    const noCheckbox = U.id('activeNoCheckbox');
    const onActiveChange = (e) => {
      if (!this.ensureOneActiveChecked(e && e.target)) return;
      this.storeActiveFlagsFromDom();
      this.getAdvisorList(false);
    };
    if (yesCheckbox) yesCheckbox.addEventListener('change', onActiveChange);
    if (noCheckbox) noCheckbox.addEventListener('change', onActiveChange);

    const addGroupBtn = U.id('addToAdvisorGroupBtn');
    if (addGroupBtn) {
      addGroupBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleAddToAdvisorGroupPanel();
      });
    }
    const addToUserGroupBtn = U.id('addToUserGroupBtn');
    if (addToUserGroupBtn) {
      addToUserGroupBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToUserGroup();
      });
    }
    const filterByGroupsBtn = U.id('filterByAdvisorGroupsBtn');
    if (filterByGroupsBtn) {
      filterByGroupsBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.filterByAdvisorGroups();
      });
    }
    await this.populateAdvisorGroupForm();

    await this.buildTableHead();

    const listData = data[EP] || {};
    const rows = Array.isArray(listData.data) ? listData.data : [];
    await this.buildTableBody(rows);

    const paginationState = listData.pagination || {
      total_count: 0,
      page_size: PAGE_SIZE,
      current_page: 1,
      total_pages: 0,
    };
    thsPage.vars.selected_page = paginationState.current_page || 1;
    this.buildPaginationButtons(paginationState);
    this.updatePaginationInfo(paginationState);

    if (listReturn) {
      delete this.vars.listRestore;
    }
  },

  normalizeActiveFlags(yes, no) {
    const activeYN_yes = !!yes;
    const activeYN_no = !!no;
    if (activeYN_yes || activeYN_no) return {activeYN_yes, activeYN_no};
    return {activeYN_yes: true, activeYN_no: false};
  },

  initActiveFlags(listRestore) {
    const f = listRestore && listRestore.filters ? listRestore.filters : null;
    const flags = f
      ? this.normalizeActiveFlags(f.activeYN_yes, f.activeYN_no)
      : {activeYN_yes: true, activeYN_no: false};
    this.vars.activeYN_yes = flags.activeYN_yes;
    this.vars.activeYN_no = flags.activeYN_no;
    if (f && f.keyword) this.vars.keyword = f.keyword;
    this.vars.first_name = f && f.first_name ? String(f.first_name) : '';
    this.vars.surname = f && f.surname ? String(f.surname) : '';
    this.vars.organisation = f && f.organisation ? String(f.organisation) : '';
    if (f && f.marketer_uuid) this.vars.marketer_uuid = f.marketer_uuid;
    if (f && f.include_groups) this.vars.include_groups = f.include_groups;
    if (f && f.exclude_groups) this.vars.exclude_groups = f.exclude_groups;
  },

  getActiveFlags() {
    return this.normalizeActiveFlags(this.vars && this.vars.activeYN_yes, this.vars && this.vars.activeYN_no);
  },

  storeActiveFlagsFromDom() {
    const yesEl = U.id('activeYesCheckbox');
    const noEl = U.id('activeNoCheckbox');
    const flags = this.normalizeActiveFlags(yesEl && yesEl.checked, noEl && noEl.checked);
    this.vars.activeYN_yes = flags.activeYN_yes;
    this.vars.activeYN_no = flags.activeYN_no;
    return flags;
  },

  syncActiveCheckboxesFromVars() {
    const flags = this.getActiveFlags();
    const yesEl = U.id('activeYesCheckbox');
    const noEl = U.id('activeNoCheckbox');
    if (yesEl) yesEl.checked = flags.activeYN_yes;
    if (noEl) noEl.checked = flags.activeYN_no;
  },

  ensureOneActiveChecked(changedEl) {
    const yesEl = U.id('activeYesCheckbox');
    const noEl = U.id('activeNoCheckbox');
    const yes = yesEl ? !!yesEl.checked : false;
    const no = noEl ? !!noEl.checked : false;
    if (yes || no) return true;
    if (changedEl) changedEl.checked = true;
    else this.syncActiveCheckboxesFromVars();
    return false;
  },

  buildRequestVars(page) {
    const flags = this.getActiveFlags();
    const vars = {
      activeYN_yes: flags.activeYN_yes,
      activeYN_no: flags.activeYN_no,
      page: page || 1,
      limit: PAGE_SIZE,
    };

    const keywordEl = U.id('advisorKeywordSearch');
    const keyword = keywordEl
      ? keywordEl.value.trim()
      : ((this.vars && this.vars.keyword) || '').trim();
    if (keyword.length >= 3) vars.keyword = keyword;

    const firstName = this.columnFilterValue('advisorFirstNameFilter', 'first_name');
    const surname = this.columnFilterValue('advisorSurnameFilter', 'surname');
    const organisation = this.columnFilterValue('advisorOrganisationFilter', 'organisation');
    if (firstName.length >= 3) vars.first_name = firstName;
    if (surname.length >= 3) vars.surname = surname;
    if (organisation.length >= 3) vars.organisation = organisation;

    if (this.vars && this.vars.marketer_uuid) {
      vars.marketer_uuid = this.vars.marketer_uuid;
    }

    const includeOnly = this.vars && this.vars.include_groups ? String(this.vars.include_groups).trim() : '';
    if (includeOnly) vars.include_groups = includeOnly;
    const excludeGroups = this.vars && this.vars.exclude_groups ? String(this.vars.exclude_groups).trim() : '';
    if (excludeGroups) vars.exclude_groups = excludeGroups;

    return vars;
  },

  captureListReturnState() {
    const keywordEl = U.id('advisorKeywordSearch');
    const flags = this.getActiveFlags();
    const filters = {
      keyword: keywordEl ? keywordEl.value.trim() : '',
      first_name: this.columnFilterValue('advisorFirstNameFilter', 'first_name'),
      surname: this.columnFilterValue('advisorSurnameFilter', 'surname'),
      organisation: this.columnFilterValue('advisorOrganisationFilter', 'organisation'),
      activeYN_yes: flags.activeYN_yes,
      activeYN_no: flags.activeYN_no,
    };
    if (this.vars && this.vars.marketer_uuid) {
      filters.marketer_uuid = this.vars.marketer_uuid;
    }
    if (this.vars && this.vars.include_groups) {
      filters.include_groups = this.vars.include_groups;
    }
    if (this.vars && this.vars.exclude_groups) {
      filters.exclude_groups = this.vars.exclude_groups;
    }
    const page = thsPage.vars.selected_page
      ? parseInt(String(thsPage.vars.selected_page), 10) || 1
      : 1;
    return {filters, selected_page: page};
  },

  applyListReturnToDom(lr) {
    if (!lr || !lr.filters) return;
    const f = lr.filters;
    const keywordEl = U.id('advisorKeywordSearch');
    if (keywordEl) keywordEl.value = f.keyword != null ? f.keyword : '';
    this.initActiveFlags(lr);
    this.syncActiveCheckboxesFromVars();
    if (f.marketer_uuid) {
      thsPage.vars.marketer_uuid = f.marketer_uuid;
    } else {
      thsPage.vars.marketer_uuid = '';
    }
    this.syncMarketerSelectFromVars();
  },

  syncMarketerSelectFromVars() {
    const marketerDD = U.id('marketerDD');
    if (!marketerDD) return;
    marketerDD.value = this.vars && this.vars.marketer_uuid ? this.vars.marketer_uuid : '';
  },

  onMarketerChange() {
    const marketerDD = U.id('marketerDD');
    const value = marketerDD ? String(marketerDD.value || '').trim() : '';
    this.vars.marketer_uuid = value;
    this.getAdvisorList(false);
  },

  async populateAdvisorGroupForm() {
    const selectMount = U.id('advisorGroupSelectMount');
    const nameMount = U.id('newAdvisorGroupNameMount');
    const includeMount = U.id('advisorGroupIncludeMount');
    const excludeMount = U.id('advisorGroupExcludeMount');
    const allGroups = Array.isArray(this.advisorGroupsData) ? this.advisorGroupsData : [];
    const prevInclude =
      selectedGroupFilterIds('advisorGroupIncludeMount').length
        ? selectedGroupFilterIds('advisorGroupIncludeMount')
        : String((this.vars && this.vars.include_groups) || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean);
    const prevExclude =
      selectedGroupFilterIds('advisorGroupExcludeMount').length
        ? selectedGroupFilterIds('advisorGroupExcludeMount')
        : String((this.vars && this.vars.exclude_groups) || '')
            .split(',')
            .map((id) => id.trim())
            .filter(Boolean);

    if (selectMount) {
      selectMount.innerHTML = '';
      const groups = allGroups
        .filter((row) => row && row.group_type === 'User')
        .map((row) => ({
          ...row,
          group_name_display: userGroupDisplayName(row),
        }));
      const groupDD = await comp.select_v2({
        elID: 'advisorGroupDD',
        ddData: groups,
        valueDataName: 'h_advisor_group_id',
        textDataName: 'group_name_display',
        labelName: 'Advisor group',
        requiredYN: 0,
      });
      const selectEl = groupDD.querySelector('#advisorGroupDD');
      if (selectEl) {
        const firstOpt = selectEl.querySelector('option[value=""]');
        if (firstOpt) firstOpt.textContent = 'Select advisor group';
        selectEl.addEventListener('change', () => this.syncAddToUserGroupBtn());
      }
      selectMount.appendChild(groupDD);
    }
    if (nameMount && !U.id('newAdvisorGroupName')) {
      nameMount.innerHTML = '';
      const nameInput = await comp.inputText('newAdvisorGroupName', '', 'Create new advisor group', 0, '', '');
      nameMount.appendChild(nameInput);
    }
    const nameEl = U.id('newAdvisorGroupName');
    if (nameEl && !nameEl.dataset.addToGroupBound) {
      nameEl.dataset.addToGroupBound = '1';
      nameEl.addEventListener('input', () => this.syncAddToUserGroupBtn());
    }

    if (includeMount) {
      includeMount.innerHTML = '';
      includeMount.appendChild(this.buildAdvisorGroupCheckList('advisorGroupInclude', allGroups, prevInclude, 'Include'));
    }
    if (excludeMount) {
      excludeMount.innerHTML = '';
      excludeMount.appendChild(this.buildAdvisorGroupCheckList('advisorGroupExclude', allGroups, prevExclude, 'Exclude'));
    }

    this.syncAddToUserGroupBtn();
  },

  buildAdvisorGroupCheckList(namePrefix, groups, selectedIds, ariaLabel) {
    const selected = new Set((selectedIds || []).map((id) => String(id)));
    const list = document.createElement('div');
    list.className = 'advisor-group-check-list';
    list.setAttribute('role', 'group');
    list.setAttribute('aria-label', ariaLabel);

    const rows = Array.isArray(groups) ? groups : [];
    if (!rows.length) {
      const empty = document.createElement('p');
      empty.className = 'advisor-group-check-empty';
      empty.textContent = 'No advisor groups found.';
      list.appendChild(empty);
      return list;
    }

    rows.forEach((row, idx) => {
      if (!row || row.h_advisor_group_id == null) return;
      const id = String(row.h_advisor_group_id);
      const rowEl = document.createElement('div');
      rowEl.className = 'advisor-group-check-row';

      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.id = `${namePrefix}_${idx}`;
      checkbox.name = namePrefix;
      checkbox.dataset.groupId = id;
      checkbox.checked = selected.has(id);
      checkbox.setAttribute('aria-label', allGroupDisplayName(row));
      checkbox.addEventListener('change', () => {
        if (!checkbox.checked) return;
        const otherMountId =
          namePrefix === 'advisorGroupInclude' ? 'advisorGroupExcludeMount' : 'advisorGroupIncludeMount';
        this.clearGroupFilterSelection(otherMountId, id);
      });

      const text = document.createElement('span');
      text.textContent = allGroupDisplayName(row);

      rowEl.appendChild(checkbox);
      rowEl.appendChild(text);
      list.appendChild(rowEl);
    });

    return list;
  },

  clearGroupFilterSelection(containerId, groupId) {
    const root = U.id(containerId);
    if (!root) return;
    const match = String(groupId);
    root.querySelectorAll('input[type="checkbox"][data-group-id]').forEach((cb) => {
      if (cb.dataset.groupId === match) cb.checked = false;
    });
  },

  async toggleAddToAdvisorGroupPanel() {
    const panel = U.id('addToAdvisorGroupPanel');
    if (!panel) return;
    if (panel.classList.contains('hide')) {
      const res = await O.PREP([await O.mPOST(GROUPS_EP, {})]);
      const groupsRes = res[GROUPS_EP] || {};
      this.advisorGroupsData = Array.isArray(groupsRes.data) ? groupsRes.data : [];
      await this.populateAdvisorGroupForm();
      U.unhide('addToAdvisorGroupPanel');
    } else {
      U.hide('addToAdvisorGroupPanel');
    }
  },

  getSelectedHUserIds() {
    return this.getPageRowCheckboxes()
      .filter((cb) => cb.checked)
      .map((cb) => cb.dataset.hUserId)
      .filter((id) => id != null && String(id).trim() !== '');
  },

  canAddToUserGroup() {
    const hasChecked = this.getSelectedHUserIds().length > 0;
    const groupEl = U.id('advisorGroupDD');
    const nameEl = U.id('newAdvisorGroupName');
    const hasGroup = !!(groupEl && String(groupEl.value || '').trim());
    const hasNewName = !!(nameEl && String(nameEl.value || '').trim().length > 5);
    return hasChecked && (hasGroup || hasNewName);
  },

  syncAddToUserGroupBtn() {
    const btn = U.id('addToUserGroupBtn');
    if (!btn) return;
    btn.disabled = !this.canAddToUserGroup();
  },

  async addToUserGroup() {
    if (!this.canAddToUserGroup()) {
      this.syncAddToUserGroupBtn();
      return;
    }
    const groupEl = U.id('advisorGroupDD');
    const nameEl = U.id('newAdvisorGroupName');
    const h_advisor_group_id = groupEl ? String(groupEl.value || '').trim() : '';
    const new_advisor_group_name = nameEl ? String(nameEl.value || '').trim() : '';
    const advisor_user_id = this.getSelectedHUserIds().join(',');

    const vars = {advisor_user_id};
    if (h_advisor_group_id) vars.h_advisor_group_id = h_advisor_group_id;
    if (new_advisor_group_name) vars.new_advisor_group_name = new_advisor_group_name;

    const res = await O.PREP([await O.mPOST(CREATE_GROUP_EP, vars)]);
    const createRes = res[CREATE_GROUP_EP] || {};
    if (createRes.status === 'OK') {
      location.reload();
      return;
    }
    const err = createRes.data && createRes.data.error;
    comp.toast(err || 'Unable to add to user group');
  },

  hasDisplayRowSelections() {
    return this.getPageRowCheckboxes().some((cb) => cb.checked);
  },

  async filterByAdvisorGroups() {
    if (this.hasDisplayRowSelections()) {
      await comp.modal(
        'Confirm',
        'Filtering now will clear your row/s selections',
        'thsPage.confirmFilterByAdvisorGroups()',
        'thsPage.cancelFilterByAdvisorGroups()'
      );
      return;
    }
    this.applyAdvisorGroupFilter();
  },

  confirmFilterByAdvisorGroups() {
    this.toggleSelectAllOnPage(false);
    this.clearPageTrigger();
    this.syncAddToUserGroupBtn();
    this.applyAdvisorGroupFilter();
  },

  cancelFilterByAdvisorGroups() {},

  applyAdvisorGroupFilter() {
    this.vars.include_groups = selectedGroupFilterIds('advisorGroupIncludeMount').join(',');
    this.vars.exclude_groups = selectedGroupFilterIds('advisorGroupExcludeMount').join(',');
    this.getAdvisorList(false);
  },

  async buildTableHead() {
    const advisorTableHead = U.id('advisorTableHead');
    advisorTableHead.innerHTML = '';
    const headRow = advisorTableHead.insertRow();

    headRow.insertCell(0);

    const selectHead = headRow.insertCell(1);
    selectHead.style.textAlign = 'center';
    const headWrap = document.createElement('div');
    headWrap.style.display = 'flex';
    headWrap.style.flexDirection = 'column';
    headWrap.style.alignItems = 'center';
    headWrap.style.justifyContent = 'center';
    headWrap.style.gap = '0.5rem';

    const selectAll = document.createElement('input');
    selectAll.type = 'checkbox';
    selectAll.id = 'advisorSelectAllCheckbox';
    selectAll.className = 'cursor-pointer';
    selectAll.style.transform = 'scale(1.4)';
    selectAll.title = 'Select all on this page';
    selectAll.addEventListener('change', (e) => {
      const checked = !!e.target.checked;
      if (checked) this.clearPageTrigger();
      this.toggleSelectAllOnPage(checked);
    });

    const pageTrigger = document.createElement('input');
    pageTrigger.type = 'checkbox';
    pageTrigger.id = 'advisorPageTriggerCheckbox';
    pageTrigger.className = 'cursor-pointer advisor-page-trigger-checkbox';
    pageTrigger.title = 'Add all records';
    pageTrigger.checked = !!(this.vars && this.vars.pageTriggerYN);
    pageTrigger.addEventListener('change', () => {
      if (pageTrigger.checked) {
        pageTrigger.checked = false;
        this.vars.pageTriggerYN = false;
        this.promptPageTrigger();
        return;
      }
      this.vars.pageTriggerYN = false;
    });

    headWrap.appendChild(pageTrigger);
    headWrap.appendChild(selectAll);
    selectHead.appendChild(headWrap);

    const firstName = headRow.insertCell(2);
    firstName.appendChild(columnFilterHead('First name', 'advisorFirstNameFilter', this.vars && this.vars.first_name));

    const lastName = headRow.insertCell(3);
    lastName.appendChild(columnFilterHead('Surname', 'advisorSurnameFilter', this.vars && this.vars.surname));

    const broker = headRow.insertCell(4);
    broker.innerHTML = 'Broker number';

    const email = headRow.insertCell(5);
    email.innerHTML = 'Email';

    const active = headRow.insertCell(6);
    active.innerHTML = 'Active';

    const retired = headRow.insertCell(7);
    retired.innerHTML = 'Retired';

    const lastContact = headRow.insertCell(8);
    lastContact.innerHTML = 'Last contact report';

    const crmFollowUp = headRow.insertCell(9);
    crmFollowUp.innerHTML = 'CRM follow up';

    const org = headRow.insertCell(10);
    org.appendChild(columnFilterHead('Organisation', 'advisorOrganisationFilter', this.vars && this.vars.organisation));

    const orgBranch = headRow.insertCell(11);
    orgBranch.innerHTML = 'Org. branch';

    const recentApplication = headRow.insertCell(12);
    recentApplication.innerHTML = 'Recent application';

    const willCount = headRow.insertCell(13);
    willCount.innerHTML = 'Will count';

    const marketer = headRow.insertCell(14);
    if (this.marketersData && this.marketersData.length) {
      const marketerDD = await comp.selectThead(
        'marketerDD',
        this.marketersData,
        'user_uuid',
        'fullName',
        'thsPage.onMarketerChange()',
        'Select marketer'
      );
      marketer.appendChild(marketerDD);
      this.syncMarketerSelectFromVars();
    } else {
      marketer.innerHTML = 'Marketer';
    }
  },

  async buildTableBody(listData) {
    const advisorTableBody = U.id('advisorTableBody');
    advisorTableBody.innerHTML = '';

    if (listData.length) {
      for (const row of listData) {
        const advisorRow = advisorTableBody.insertRow();

        const viewAdvisor = advisorRow.insertCell(0);
        viewAdvisor.className = 'advisor-icon-cell';
        const linkSVG = svg.linkNewPage();
        linkSVG.style.cursor = 'pointer';
        linkSVG.setAttribute('role', 'button');
        linkSVG.setAttribute('title', 'View advisor');
        linkSVG.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          listReturnState.save('ViewAdvisor', {
            listPage: 'ManageAdvisors',
            state: this.captureListReturnState(),
          });
          O.PREP('ViewAdvisor', `advisor_uuid=${row.advisor_uuid}`);
        });
        viewAdvisor.appendChild(linkSVG);

        const selectCell = advisorRow.insertCell(1);
        selectCell.className = 'advisor-check-cell';
        const rowCheckbox = document.createElement('input');
        rowCheckbox.type = 'checkbox';
        rowCheckbox.className = 'cursor-pointer';
        rowCheckbox.dataset.hUserId = row.h_user_id != null ? String(row.h_user_id) : '';
        rowCheckbox.addEventListener('change', () => {
          this.syncSelectAllCheckbox();
          this.syncAddToUserGroupBtn();
        });
        selectCell.appendChild(rowCheckbox);

        const firstName = advisorRow.insertCell(2);
        firstName.textContent = cellText(row.advisor_f_name);

        const lastName = advisorRow.insertCell(3);
        lastName.textContent = cellText(row.advisor_s_name);

        const broker = advisorRow.insertCell(4);
        broker.textContent = cellText(row.broker_number);

        const email = advisorRow.insertCell(5);
        email.textContent = cellText(row.email_address);

        const active = advisorRow.insertCell(6);
        const isActive = row.active_yn === true || row.active_yn === 'true' || row.active_yn === 1;
        const tag = await comp.statusTag(isActive ? 'Active' : 'Inactive');
        active.appendChild(tag);

        const retired = advisorRow.insertCell(7);
        retired.textContent = ynText(row.retired_yn);

        const lastContact = advisorRow.insertCell(8);
        lastContact.textContent = await dateText(row.last_contact_report);

        const crmFollowUp = advisorRow.insertCell(9);
        crmFollowUp.textContent = await dateText(row.crm_follow_up);
        styleOverdueCrmFollowUp(crmFollowUp, row.crm_follow_up, row.last_contact_report);

        const org = advisorRow.insertCell(10);
        org.textContent = cellText(row.orgname);

        const orgBranch = advisorRow.insertCell(11);
        orgBranch.textContent = cellText(row.orgbranch);

        const recentApplication = advisorRow.insertCell(12);
        recentApplication.textContent = await dateText(row.latest_application_created_date);

        const willCount = advisorRow.insertCell(13);
        willCount.textContent =
          row.will_count != null && String(row.will_count).trim() !== '' ? String(row.will_count) : '—';

        const marketer = advisorRow.insertCell(14);
        marketer.textContent = marketerName(row);
      }
    } else {
      const advisorRow = advisorTableBody.insertRow();
      const empty = advisorRow.insertCell(0);
      empty.innerHTML = 'No advisors available.';
      empty.colSpan = COL_COUNT;
    }

    this.syncSelectAllCheckbox();
    this.syncAddToUserGroupBtn();
  },

  clearGroupFilterCheckboxes() {
    ['advisorGroupIncludeMount', 'advisorGroupExcludeMount'].forEach((id) => {
      const root = U.id(id);
      if (!root) return;
      root.querySelectorAll('input[type="checkbox"][data-group-id]').forEach((cb) => {
        cb.checked = false;
      });
    });
  },

  getPageRowCheckboxes() {
    const body = U.id('advisorTableBody');
    if (!body) return [];
    return [...body.querySelectorAll('input[type="checkbox"][data-h-user-id]')];
  },

  toggleSelectAllOnPage(checked) {
    this.getPageRowCheckboxes().forEach((checkbox) => {
      checkbox.checked = !!checked;
    });
    this.syncSelectAllCheckbox();
    this.syncAddToUserGroupBtn();
  },

  getTotalRecordsCount() {
    const el = U.id('totalRecordsDisplay');
    const raw = el && el.textContent != null ? String(el.textContent).trim() : '';
    if (!raw || raw === '-') return 0;
    const n = parseInt(raw.replace(/,/g, ''), 10);
    return Number.isFinite(n) ? n : 0;
  },

  async promptPageTrigger() {
    const total = this.getTotalRecordsCount();
    await comp.modal(
      'Confirm',
      `Are you sure you want to add all ${total} records`,
      'thsPage.confirmPageTrigger()',
      'thsPage.cancelPageTrigger()'
    );
  },

  clearPageTrigger() {
    const pageTrigger = U.id('advisorPageTriggerCheckbox');
    if (pageTrigger) pageTrigger.checked = false;
    this.vars.pageTriggerYN = false;
  },

  confirmPageTrigger() {
    const pageTrigger = U.id('advisorPageTriggerCheckbox');
    if (pageTrigger) pageTrigger.checked = true;
    this.vars.pageTriggerYN = true;
    this.toggleSelectAllOnPage(false);
  },

  cancelPageTrigger() {
    this.clearPageTrigger();
  },

  syncSelectAllCheckbox() {
    const selectAll = U.id('advisorSelectAllCheckbox');
    if (!selectAll) return;
    const checkboxes = this.getPageRowCheckboxes();
    if (!checkboxes.length) {
      selectAll.checked = false;
      selectAll.indeterminate = false;
      return;
    }
    const checkedCount = checkboxes.filter((cb) => cb.checked).length;
    selectAll.checked = checkedCount === checkboxes.length;
    selectAll.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length;
  },

  async buildPaginationButtons(paginationState) {
    const totalPages = paginationState.total_pages || 0;
    const wrapper = U.id('advisorPaginationWrapper');
    if (totalPages > 0) {
      await comp.paginationButtons({
        totalPages,
        wrapperID: 'advisorPaginationWrapper',
      });
      const pageButtons = document.querySelectorAll('#advisorPaginationWrapper .pageButton');
      pageButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          thsPage.vars.selected_page = Number(e.target.getAttribute('value'));
          this.getAdvisorList(false, true);
        });
      });
    } else if (wrapper) {
      wrapper.innerHTML = '';
    }
    this.updatePaginationInfo(paginationState);
  },

  updatePaginationInfo(paginationState) {
    const totalRecords = paginationState.total_count != null
      ? paginationState.total_count
      : paginationState.total_records;
    const totalPages = paginationState.total_pages;

    const totalRecordsTop = U.id('totalRecordsDisplay');
    const totalPagesTop = U.id('totalPagesDisplay');
    if (totalRecordsTop) {
      totalRecordsTop.textContent = totalRecords != null ? totalRecords : '-';
    }
    if (totalPagesTop) {
      totalPagesTop.textContent = totalPages != null ? totalPages : '-';
    }

    const totalRecordsBottom = U.id('totalRecordsDisplayBottom');
    const totalPagesBottom = U.id('totalPagesDisplayBottom');
    if (totalRecordsBottom) {
      totalRecordsBottom.textContent = totalRecords != null ? totalRecords : '-';
    }
    if (totalPagesBottom) {
      totalPagesBottom.textContent = totalPages != null ? totalPages : '-';
    }
  },

  async fetchAndRenderAdvisorList(vars, quiet) {
    let res;
    if (quiet) {
      const hdrs = await O.getAuthHdrs();
      const method = await O.mPOST(EP, vars);
      res = await O.exRequest({methods: [method], hdrs});
    } else {
      res = await O.PREP([await O.mPOST(EP, vars)]);
    }
    const listData = res[EP] || {};
    const rows = Array.isArray(listData.data) ? listData.data : [];
    const paginationState = listData.pagination || {
      total_count: 0,
      page_size: PAGE_SIZE,
      current_page: vars.page || 1,
      total_pages: 0,
    };

    await this.buildTableBody(rows);
    thsPage.vars.selected_page = paginationState.current_page || vars.page || 1;
    this.buildPaginationButtons(paginationState);
    this.updatePaginationInfo(paginationState);
  },

  async getAdvisorList(filtersCleared, fromPagination, immediate, quiet) {
    clearTimeout(advisorListTimeout);
    clearTimeout(advisorColumnFilterTimeout);
    if (!immediate) {
      clearTimeout(advisorKeywordTimeout);
    }

    if (filtersCleared) {
      const keywordEl = U.id('advisorKeywordSearch');
      if (keywordEl) keywordEl.value = '';
      this.vars.keyword = '';
      this.vars.activeYN_yes = true;
      this.vars.activeYN_no = false;
      this.vars.marketer_uuid = '';
      this.vars.first_name = '';
      this.vars.surname = '';
      this.vars.organisation = '';
      this.columnFiltersApplied = false;
      this.vars.include_groups = '';
      this.vars.exclude_groups = '';
      this.clearGroupFilterCheckboxes();
      this.syncActiveCheckboxesFromVars();
      this.syncMarketerSelectFromVars();
      ['advisorFirstNameFilter', 'advisorSurnameFilter', 'advisorOrganisationFilter'].forEach((id) => {
        const el = U.id(id);
        if (el) el.value = '';
      });
      this.updateKeywordClearBtn();
      thsPage.vars.selected_page = 1;
    } else if (!fromPagination) {
      thsPage.vars.selected_page = 1;
    }

    advisorListTimeout = setTimeout(async () => {
      const vars = this.buildRequestVars(parseInt(thsPage.vars.selected_page, 10) || 1);
      try {
        await this.fetchAndRenderAdvisorList(vars, quiet);
      } catch (error) {
      }
    }, fromPagination || immediate ? 0 : 500);
  },

  updateKeywordClearBtn() {
    const keywordEl = U.id('advisorKeywordSearch');
    const clearBtn = U.id('advisorKeywordClear');
    if (!clearBtn) return;
    clearBtn.hidden = !(keywordEl && keywordEl.value);
  },

  columnFilterValue(inputId, varName) {
    const el = U.id(inputId);
    const raw = el ? el.value : this.vars && this.vars[varName];
    return String(raw || '').trim();
  },

  onColumnFilterInput() {
    clearTimeout(advisorColumnFilterTimeout);
    advisorColumnFilterTimeout = setTimeout(() => {
      const fields = [
        this.columnFilterValue('advisorFirstNameFilter', 'first_name'),
        this.columnFilterValue('advisorSurnameFilter', 'surname'),
        this.columnFilterValue('advisorOrganisationFilter', 'organisation'),
      ];
      this.vars.first_name = fields[0];
      this.vars.surname = fields[1];
      this.vars.organisation = fields[2];
      const ready = fields.some((value) => value.length >= 3);
      const cleared = fields.every((value) => value.length < 3);
      if (!ready && !(cleared && this.columnFiltersApplied)) return;
      this.columnFiltersApplied = ready;
      this.getAdvisorList(false, false, true, true);
    }, 1000);
  },

  onKeywordInput() {
    clearTimeout(advisorKeywordTimeout);
    const keywordEl = U.id('advisorKeywordSearch');
    const keyword = keywordEl ? keywordEl.value.trim() : '';

    if (keyword.length === 0) {
      this.getAdvisorList(false, false, true);
      return;
    }

    if (keyword.length < 3) {
      return;
    }

    advisorKeywordTimeout = setTimeout(() => {
      this.getAdvisorList(false, false, true);
    }, 1000);
  },

  setupSearchInputEvents() {
    const keywordEl = U.id('advisorKeywordSearch');
    const clearKeywordBtn = U.id('advisorKeywordClear');
    if (!keywordEl) return;

    keywordEl.addEventListener('input', () => {
      this.updateKeywordClearBtn();
      this.onKeywordInput();
    });

    if (clearKeywordBtn) {
      clearKeywordBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        clearTimeout(advisorKeywordTimeout);
        keywordEl.value = '';
        this.updateKeywordClearBtn();
        keywordEl.focus();
        this.getAdvisorList(false, false, true);
      });
    }

    this.updateKeywordClearBtn();
  },
};
